import { inventory } from '@toggle/toggle';
import { z } from 'zod';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export type ConversationInventory = z.infer<
  typeof inventory.conversationInventory.schema
>;

export type FormattedConversationInventory = ConversationInventory & {
  insightTitles?: Record<string, string>;
};

export const getConversationInventory = (conversationId: string) =>
  wretchRequest<ConversationInventory>(
    inventory.conversationInventory.path(conversationId),
    {
      schema: inventory.conversationInventory.schema,
    }
  );
